import { Calendar } from "lucide-react";
import { Accordion, CeremonyFormFields } from "@/components/customer/events";
import { useTranslation } from "@/hooks/useTranslation";

interface BaptismCeremonyAccordionProps {
  /** Overrides the default heading (JUB-154: the separate baptism slot). */
  title?: string;
  enabled: boolean;
  date: string;
  time: string;
  locationName: string;
  address: string;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
  onLocationNameChange: (value: string) => void;
  onAddressChange: (value: string) => void;
}

export function BaptismCeremonyAccordion({
  title,
  enabled,
  date,
  time,
  locationName,
  address,
  onDateChange,
  onTimeChange,
  onLocationNameChange,
  onAddressChange,
}: BaptismCeremonyAccordionProps) {
  const { t } = useTranslation();
  if (!enabled) {
    return null;
  }

  return (
    <Accordion
      title={title ?? t("events.form.baptismCeremony")}
      icon={<Calendar className="h-6 w-6 text-pink-600 dark:text-pink-400" />}
      defaultOpen={false}
    >
      <CeremonyFormFields
        date={date}
        time={time}
        locationName={locationName}
        address={address}
        onDateChange={onDateChange}
        onTimeChange={onTimeChange}
        onLocationNameChange={onLocationNameChange}
        onAddressChange={onAddressChange}
      />
    </Accordion>
  );
}
